import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { DashboardView } from "@/feature/dashboard/presentation/view/DashboardView";
import { RewardCatalogView } from "@/feature/reward-catalog/presentation/view/RewardCatalogView";
import { RewardCatalogCreateView } from "@/feature/reward-catalog/presentation/view/RewardCatalogCreateView/RewardCatalogCreateView";
import { TieringSettingsView } from "@/feature/tiering-settings/presentation/view/TieringSettingsView";
import { TieringSettingsFormView } from "@/feature/tiering-settings/presentation/view/TieringSettingsFormView/TieringSettingsFormView";
import { ProgramsView } from "@/feature/programs/presentation/view/ProgramsView";
import { ProgramsFormView } from "@/feature/programs/presentation/view/ProgramsFormView";
import { MerchantApprovalView } from "@/feature/merchant-approval/presentation/view/MerchantApprovalView";
import { MerchantApprovalDetailView } from "@/feature/merchant-approval/presentation/view/MerchantApprovalDetailView";
import { LoginView } from "@/feature/auth/presentation/view/LoginView";
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";

/**
 * Layout wrapper for protected routes
 * Wraps all child routes with authentication check
 */
const ProtectedLayout = (): React.JSX.Element => {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
};

export const AppRouter = (): React.JSX.Element => {
  return (
    <Routes>
      {/* Redirect root to dashboard (will redirect to login if not authenticated) */}
      <Route
        path="/"
        element={<Navigate to="/swarapoint/dashboard" replace />}
      />

      {/* Public route - redirects to dashboard if already logged in */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <LoginView />
          </PublicRoute>
        }
      />

      {/* Protected routes - all routes under /swarapoint require authentication */}
      <Route path="/swarapoint" element={<ProtectedLayout />}>
        <Route path="dashboard" element={<DashboardView />} />
        <Route path="reward-catalog" element={<RewardCatalogView />} />
        <Route
          path="reward-catalog/create"
          element={<RewardCatalogCreateView />}
        />
        <Route
          path="reward-catalog/edit/:id"
          element={<RewardCatalogCreateView />}
        />
        <Route path="tiering-settings" element={<TieringSettingsView />} />
        <Route
          path="tiering-settings/create"
          element={<TieringSettingsFormView />}
        />
        <Route
          path="tiering-settings/edit/:id"
          element={<TieringSettingsFormView />}
        />
        <Route path="programs" element={<ProgramsView />} />
        <Route path="programs/create" element={<ProgramsFormView />} />
        <Route path="programs/edit/:id" element={<ProgramsFormView />} />
        <Route path="merchant-approval" element={<MerchantApprovalView />} />
        <Route path="merchant-approval/:id" element={<MerchantApprovalDetailView />} />
      </Route>

      {/* Catch-all redirect to dashboard */}
      <Route
        path="*"
        element={<Navigate to="/swarapoint/dashboard" replace />}
      />
    </Routes>
  );
};
